import {
  IconButton as ChakraIconButton,
  IconButtonProps as ChakraIconButtonProps,
} from '@chakra-ui/react'
import * as React from 'react'

export type IconButtonProps = ChakraIconButtonProps

export const IconButton = React.forwardRef<
  HTMLButtonElement,
  ChakraIconButtonProps
>(function IconButton(props, ref) {
  const { colorPalette, size = 'md', ...rest } = props

  const color =
    colorPalette === 'gray' ? 'colorPalette.700' : 'colorPalette.500'
  const bgColor = 'transparent'
  const hoverBgColor = 'colorPalette.500/8'
  const hoverBg =
    'var(--hover-bg-color) radial-gradient(circle, var(--hover-bg-color) 1%, transparent 1%) center/20000%'
  const activeBgColor = 'colorPalette.500/16'
  const iconSize = size === 'lg' || size === 'md' ? '24px' : '16px'

  return (
    <ChakraIconButton
      colorPalette={colorPalette}
      variant="ghost"
      size={size}
      color={color}
      borderRadius="base"
      bgColor={bgColor}
      bgPos="center"
      transition="background 0.8s"
      css={{
        '--hover-bg-color': `{colors.${hoverBgColor}}`,
        '&:hover': {
          background: hoverBg,
        },
        '&:active': {
          backgroundColor: activeBgColor,
          backgroundSize: '100%',
          transition: 'background 0s',
        },
        '& :where(svg)': { width: iconSize, height: iconSize },
      }}
      {...rest}
      ref={ref}
    />
  )
})
